import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import InfiniteScroll from "react-infinite-scroll-component";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  AudioOutlined,
  CameraOutlined,
  CloseOutlined,
  DeleteOutlined,
  FileTextOutlined,
  LeftOutlined,
  PlayCircleFilled,
  PlusOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { uuid } from "@ant-design/plots/es/utils";
import {
  Avatar,
  Button,
  Empty,
  Input,
  List,
  Menu,
  Modal,
  Popover,
  Tag,
  Tooltip,
  Typography,
} from "antd";
import {
  DocumentIcon,
  ImageIcon,
  SendMessHorizontalBlueIcon,
  TemplateIcon,
} from "assets/icons";
import {
  MESSAGE_DATA_TYPE,
  MESSAGE_DIRECTION_TYPE,
  STATUS_TYPE,
} from "constants/appConstant";
import httpRequest from "services/httpRequest";
import { AuthInfo } from "stores/slices/auth";
import { doGetAllCategory } from "stores/slices/category";
import {
  doUpdateConversation,
  getConversationSelected,
  getNewConversation,
  isLockCurrentConversation,
  selectIsLockNotCurrentSessionConversation,
  setCurrentLockConversation,
  setIsLockConversation,
} from "stores/slices/conversation";
import { doCompleteMediaContent } from "stores/slices/mediaContent";
import {
  addMessage,
  doReadAllMessage,
  doSendMessage,
  setFileUpList,
  setProgress,
} from "stores/slices/message";
import { isSaving } from "stores/slices/message";
import {
  doGetAllMessageTemplate,
  doGetMessageTemplatePage,
} from "stores/slices/messageTemplate";
import { getNotification } from "stores/slices/notification";
// import { WorkspaceInfo } from "stores/slices/workspace";
import StorageHelper from "utils/storeHelper";
import { v4 as uuidv4 } from "uuid";

import AudioRecord from "components/audio/audioRecord";
import Camera from "components/camera/camera";
import ModalForm from "components/forms/components/modalForm";

const { TextArea } = Input;

const ChatMessageFooter = props => {
  const { inputUploadFileRef, inputUploadImgRef, serviceSelected } = props;
  const btnRef = useRef(null);
  const inputSendMessageRef = useRef(null);
  const audioRecordRef = useRef(null);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { id } = useParams();
  const authInfo = useSelector(AuthInfo);
  const conversationSelected = useSelector(getConversationSelected);
  const loading = useSelector(isSaving);
  const messageNotification = useSelector(getNotification);
  const isCurrentLockConversation = useSelector(isLockCurrentConversation);
  const isLockNotCurrentSessionConversation = useSelector(
    selectIsLockNotCurrentSessionConversation
  );
  const newConversation = useSelector(getNewConversation);

  // const workspaceInfo = useSelector(WorkspaceInfo);
  // const { workspaceSetting } = workspaceInfo;

  const [openMessageTemplate, setOpenMessageTemplate] = useState(false);
  const [isGetMessTemplatePage, setIsGetMessTemplatePage] = useState(false);
  const [messageTemplateList, setMessageTemplateList] = useState([]);
  const [isShowSendMessage, setIsShowSendMessage] = useState(false);
  const [isShowCategory, setIsShowCategory] = useState(false);
  const [isShowTemplate, setIsShowTemplate] = useState(false);
  const [fileUploadImgList, setFileUploadImgList] = useState([]);
  const [fileUploadFileList, setFileUploadFileList] = useState([]);
  const [message, setMessage] = useState("");
  const [tags, setTags] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [isLoadingMessageTemplate, setIsLoadingMessageTemplate] =
    useState(false);
  const [pageMessageTemplate, setPageMessageTemplate] = useState(null);
  const [hasMore, setHasMore] = useState(false);
  const [category, setCategory] = useState(null);
  const [isUpdateLock, setIsUpdateLock] = useState(false);
  const [isOpenCamera, setIsOpenCamera] = useState(false);
  const [isShowVideo, setIsShowVideo] = useState(false);
  const [isCaptureSuccess, setIsCaptureSuccess] = useState(false);
  const [fileAudioUpload, setFileAudioUpload] = useState(null);
  const [isStartAudioRecording, setIsStartAudioRecording] = useState(false);

  const handleUploadAudio = async (fileAudio, message) => {
    try {
      const formData = new FormData();
      formData.append("file", fileAudio);
      const request = {
        cannedAccessControlList: "PublicRead",
        conversationId: conversationSelected.id,
        messageId: message.id,
        file: fileAudio,
      };
      const response = await httpRequest({
        url: `/api/media-content`,
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
        },
        params: {
          cannedAccessControlList: request.cannedAccessControlList,
          conversationId: request.conversationId,
          messageId: request.messageId,
        },
        data: formData,
      });
      if (response && response.status === 200) {
        await dispatch(doCompleteMediaContent(message.id));
        await dispatch(addMessage(message));
        await setIsShowSendMessage(false);
        await setIsStartAudioRecording(false);
        await handleLockConversation(conversationSelected, false);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleSendAudioMessage = async fileAudio => {
    if (fileAudio) {
      const messageRequest = {
        type: "MEDIA",
        conversationId: conversationSelected.id,
        externalId: uuidv4().replace(/-/g, ""),
      };

      const { payload } = await dispatch(doSendMessage(messageRequest));
      if (payload && payload.status === 200) {
        const newMessage = {
          conversationId: messageRequest.conversationId,
          id: messageRequest.externalId,
          messageDirection: "OUT",
          messageDataType: "MEDIA",
          mediaContents: [
            {
              id: fileAudio.id,
              filename: fileAudio.name,
              location: fileAudio.url,
              type: fileAudio.type && fileAudio.type.toUpperCase(),
            },
          ],
        };
        handleUploadAudio(fileAudio, newMessage);
      }
    }
  };

  useEffect(() => {
    // Handle upload audio file from Audio component
    if (fileAudioUpload && fileAudioUpload.file) {
      handleSendAudioMessage(fileAudioUpload.file);
    }
  }, [fileAudioUpload]);

  const handleSearchMessTemplate = async e => {
    setIsLoadingMessageTemplate(true);
    const params = {
      pageNumber: 1,
      pageSize: 10,
      searchKeyMessage: e.target.value,
      sortField: "createdTime",
      sortDirection: "DESC",
      categoryId: category.id,
    };
    const { payload } = await dispatch(doGetMessageTemplatePage(params));
    setMessageTemplateList([...payload.content]);
    setIsLoadingMessageTemplate(false);
  };

  const handleGetCategory = async () => {
    if (authInfo && authInfo.workspaceId) {
      const request = {
        workspaceId: authInfo.workspaceId,
      };
      const { payload } = await dispatch(doGetAllCategory(request));
      if (payload && payload.status === 200) {
        setCategoryList([...payload.data]);
      }
    }
  };

  const handleLockConversation = (conversationSelected, lock) => {
    if (
      authInfo &&
      authInfo.id &&
      authInfo.sessionId &&
      conversationSelected &&
      conversationSelected.id
    ) {
      let request = {
        id: conversationSelected.id,
        lockConversation: lock,
      };
      dispatch(doUpdateConversation(request));
    }
  };

  const handleBeforeUploadFile = e => {
    let fileReviewList = [];
    let fileList = [];
    let fileBeforeUpload;
    const maxTotalSize = 5 * 1024 * 1024; // 5 MB
    fileBeforeUpload = [...e.target.files];
    let files = fileBeforeUpload.filter(file => {
      if (file.size === 0) {
        Modal.error({
          title: `Upload ${file.name} file failed`,
          content: "Do not upload a file 0 MB or file error",
        });
        return;
      } else {
        return file;
      }
    });
    fileList = [...files];
    const totalSize = fileList?.reduce((acc, file) => acc + file.size, 0);
    if (totalSize > maxTotalSize) {
      Modal.error({
        title: "Upload file failed",
        content: "Upload file size must be less than 5 MB",
      });
      setFileUploadFileList([]);
      setIsShowSendMessage(false);
    } else {
      for (let i = 0; i < fileList.length; i++) {
        const file = fileList[i];
        if (file) {
          let fileInfo = {
            id: uuid(),
            name: file.name,
            file: file,
            url: URL.createObjectURL(file),
            type: "file",
          };
          fileReviewList = [...fileReviewList, fileInfo];
        }
        inputSendMessageRef.current.focus({
          cursor: "end",
        });
        setIsShowSendMessage(true);
      }
      setFileUploadFileList([...fileUploadFileList, ...fileReviewList]);
    }
  };

  const handleBeforeUploadImage = e => {
    let fileReviewList = [];
    let fileList = [];
    const maxTotalSize = 5 * 1024 * 1024; // 5 MB
    fileList = [...e.target.files];
    const totalSize = fileList?.reduce((acc, file) => acc + file.size, 0);
    if (totalSize > maxTotalSize) {
      Modal.error({
        title: "Upload file failed",
        content: "Upload file size must be less than 5 MB",
      });
      setFileUploadImgList([]);
      setIsShowSendMessage(false);
    } else {
      for (let i = 0; i < fileList.length; i++) {
        const file = fileList[i];
        if (file) {
          let fileInfo = {
            id: uuid(),
            name: file.name,
            file: file,
            url: URL.createObjectURL(file),
            type: file.type.startsWith("image") ? "image" : "video",
          };
          fileReviewList = [...fileReviewList, fileInfo];
        }
        inputSendMessageRef.current.focus({
          cursor: "end",
        });
        setIsShowSendMessage(true);
      }
      setFileUploadImgList([...fileUploadImgList, ...fileReviewList]);
    }
  };

  const handleUpload = async (fileUploadList, message) => {
    try {
      const uploadPromises = fileUploadList.map(async fileItem => {
        const formData = new FormData();
        formData.append("file", fileItem.file);
        const request = {
          cannedAccessControlList: "PublicRead",
          conversationId: conversationSelected.id,
          messageId: message.id,
          file: fileItem.file,
        };
        const response = await httpRequest({
          url: `/api/media-content`,
          method: "POST",
          headers: {
            "Content-Type": "multipart/form-data",
          },
          params: {
            cannedAccessControlList: request.cannedAccessControlList,
            conversationId: request.conversationId,
            messageId: request.messageId,
          },
          data: formData,
          onUploadProgress: progressEvent => {
            const { loaded, total } = progressEvent;
            const progressCompleted = Math.floor((loaded / total) * 100);
            dispatch(setProgress(progressCompleted));
          },
        });
        return response.status === 200;
      });

      const results = await Promise.all(uploadPromises);
      if (results && results.length > 0) {
        await dispatch(doCompleteMediaContent(message.id));
        await dispatch(setProgress(0));
        await dispatch(addMessage(message));
        await dispatch(setFileUpList([]));
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleRemoveImage = fileReview => {
    if (fileUploadImgList && fileUploadImgList.length > 0) {
      let fileReviewIndex = fileUploadImgList.findIndex(
        fileItem => fileItem.file.name === fileReview?.file?.name
      );
      if (fileReviewIndex !== -1) {
        fileUploadImgList.splice(fileReviewIndex, 1);
        setFileUploadImgList([...fileUploadImgList]);
      }
    }

    if (fileUploadImgList.length === 0) {
      setIsShowSendMessage(false);
      setFileUploadImgList([]);
      inputUploadImgRef.current.value = [];
    }
  };

  const handleRemoveFile = fileReview => {
    if (fileUploadFileList && fileUploadFileList.length > 0) {
      let fileReviewIndex = fileUploadFileList.findIndex(
        fileItem => fileItem.file.name === fileReview?.file?.name
      );
      if (fileReviewIndex !== -1) {
        fileUploadFileList.splice(fileReviewIndex, 1);
        setFileUploadFileList([...fileUploadFileList]);
      }
    }

    if (fileUploadFileList.length === 0) {
      setIsShowSendMessage(false);
      setFileUploadFileList([]);
      inputUploadFileRef.current.value = [];
    }
  };

  const handleInputMessage = e => {
    // Handle show/hide button send message
    if (e.target.value) {
      StorageHelper.setLocalItem(id, e.target.value);
      setMessage(e.target.value);
      setIsShowSendMessage(true);
    } else {
      StorageHelper.removeLocalItem(conversationSelected?.id);
      setMessage("");
      setIsShowSendMessage(false);
    }
  };

  const handleKeyUp = e => {
    e.preventDefault();
    let timeout = null;
    clearTimeout(timeout);
    setIsUpdateLock(false);
    timeout = setTimeout(() => {
      if (e.target.value) {
        setIsUpdateLock(true);
      }
    }, 2000);
  };

  const handleKeyPress = e => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      // Send message
      if (
        message?.trim() !== "" ||
        (fileUploadImgList && fileUploadImgList.length > 0) ||
        (fileUploadFileList && fileUploadFileList.length > 0)
      ) {
        handleSendMessage([...fileUploadImgList, ...fileUploadFileList]);
      }
    }
  };

  const handleSendMessage = async fileUploadList => {
    if (fileUploadList && fileUploadList.length > 0) {
      const messageRequest = {
        message: message.trim(),
        type: "MEDIA",
        conversationId: conversationSelected.id,
        externalId: uuidv4().replace(/-/g, ""),
      };

      setIsShowSendMessage(false);
      setMessage("");
      dispatch(setCurrentLockConversation(false));
      const { payload } = await dispatch(doSendMessage(messageRequest));
      if (payload && payload.status === 200) {
        const newFileUploadList = fileUploadList.map(fileItem => {
          return {
            id: fileItem.id,
            filename: fileItem.name,
            type: fileItem.type.toUpperCase(),
            location: fileItem.url,
          };
        });
        const newMessage = {
          conversationId: messageRequest.conversationId,
          id: messageRequest.externalId,
          message: messageRequest.message,
          messageDirection: MESSAGE_DIRECTION_TYPE.OUT,
          messageDataType: MESSAGE_DATA_TYPE.MEDIA,
          messageType: conversationSelected?.lastMessageType,
          mediaContents: [...newFileUploadList],
        };
        // Set file upload list to show number file upload to UI
        await dispatch(setFileUpList([...newFileUploadList]));
        handleUpload(fileUploadList, newMessage);
        setFileUploadImgList([]);
        setFileUploadFileList([]);
        StorageHelper.removeLocalItem(id);
        setIsOpenCamera(false);
        setIsCaptureSuccess(false);
        setIsStartAudioRecording(false);
        handleLockConversation(conversationSelected, false);
        dispatch(setIsLockConversation(false));
      }
    } else {
      const messageRequest = {
        message: message.trim(),
        type: "MESSAGE",
        conversationId: conversationSelected.id,
        externalId: uuidv4().replace(/-/g, ""),
      };
      const newMessage = {
        conversationId: messageRequest.conversationId,
        id: messageRequest.externalId,
        message: messageRequest.message,
        type: messageRequest.type,
        messageDirection: MESSAGE_DIRECTION_TYPE.OUT,
        messageDataType: MESSAGE_DATA_TYPE.MESSAGE,
      };
      await dispatch(addMessage(newMessage));
      handleLockConversation(conversationSelected, false);
      dispatch(setCurrentLockConversation(false));
      setMessage("");
      setIsShowSendMessage(false);
      const { payload } = await dispatch(doSendMessage(messageRequest));
      if (payload && payload.status === 200) {
        StorageHelper.removeLocalItem(id);
      }
    }
  };

  const loadDataMessageTemplate = async () => {
    const params = {
      pageNumber: 1,
      pageSize: 10,
      sortField: "createdTime",
      sortDirection: "DESC",
      workspaceId: authInfo?.workspaceId,
    };

    const { payload } = await dispatch(doGetAllMessageTemplate(params));
    if (payload && payload.data && payload.data.length > 0) {
      let newTagList = payload.data.map(item => {
        let messageTemplate = {
          id: item.id,
          tags: item?.tags && item?.tags.split(","),
          message: item.message,
        };
        return messageTemplate;
      });
      setTags([...newTagList]);
    }
  };

  const handleInputMessageByTag = (messageItem, tags) => {
    if (message === "") {
      let messageData = tags.find(item => {
        if (
          item?.tags &&
          item?.tags?.find(tag =>
            messageItem.toLowerCase().includes(tag.toLowerCase())
          )
        ) {
          return item;
        }
      });
      if (
        messageData &&
        messageData !== undefined &&
        messageData !== null &&
        messageData.message !== undefined &&
        messageData.message !== null &&
        messageData.message !== ""
      ) {
        setMessage(messageData.message);
        // handleLockConversation(conversationSelected, true);
        setIsShowSendMessage(true);
        inputSendMessageRef.current.focus({
          cursor: "end",
        });
      }
    }
  };

  const handleReadMessage = () => {
    if (
      (conversationSelected && conversationSelected.totalUnread > 0) ||
      conversationSelected.totalUnread > 0
    ) {
      setTimeout(async () => {
        const request = {
          id: conversationSelected.id,
        };
        await dispatch(doReadAllMessage(request));
      }, 1000);
    }
  };

  const handleGetPageMessageTemplate = async category => {
    if (category && category.id) {
      setIsLoadingMessageTemplate(true);
      const params = {
        pageNumber: 1,
        pageSize: 10,
        sortField: "createdTime",
        sortDirection: "DESC",
        categoryId: category.id,
        statuses: [STATUS_TYPE.ACTIVE],
      };
      const { payload } = await dispatch(doGetMessageTemplatePage(params));
      setMessageTemplateList([...payload.content]);
      setPageMessageTemplate({
        pageNumber: payload.pageNumber,
        totalPages: payload.totalPages,
      });
      setIsLoadingMessageTemplate(false);
    }
  };
  const loadMoreMessageTemplate = async () => {
    if (
      category &&
      category.id &&
      pageMessageTemplate?.pageNumber < pageMessageTemplate?.totalPages
    ) {
      setIsLoadingMessageTemplate(true);
      const params = {
        pageNumber: pageMessageTemplate.pageNumber + 1,
        pageSize: 10,
        sortField: "createdTime",
        sortDirection: "DESC",
        statuses: [STATUS_TYPE.ACTIVE],
        categoryId: category.id,
      };
      const { payload } = await dispatch(doGetMessageTemplatePage(params));
      setMessageTemplateList([...messageTemplateList, ...payload.content]);
      setIsLoadingMessageTemplate(false);
      setPageMessageTemplate({
        pageNumber: payload.pageNumber,
        totalPages: payload.totalPages,
      });
    }
  };

  const handleScroll = eve => {
    const clientHeight = eve.target.clientHeight;
    const scrollTop = eve.target.scrollTop;
    const scrollHeight = eve.target.scrollHeight;
    if (
      clientHeight + 20 - (scrollHeight - scrollTop) > 0 &&
      pageMessageTemplate.pageNumber <= pageMessageTemplate.totalPages
    ) {
      setHasMore(true);
    }
  };

  const items = [
    {
      label: (
        <span>{t("inbox.chatMessage.chatMessageFooter.messageTemplate")}</span>
      ),
      className: "templates",
      key: "templates",
      icon: <TemplateIcon />,
      onClick: () => {
        setIsShowCategory(true);
      },
    },
    {
      label: (
        <span>{t("inbox.chatMessage.chatMessageFooter.audioRecording")}</span>
      ),
      className: "audio",
      key: "audio",
      icon: (
        <AudioOutlined
          style={{ fontSize: 18, color: "#626576", marginRight: 4 }}
        />
      ),
      onClick: () => {
        dispatch(setCurrentLockConversation(true));
        handleLockConversation(conversationSelected, true);
        setIsStartAudioRecording(true);
        setOpenMessageTemplate(false);
      },
      // disabled: !workspaceSetting?.sendReceiveMms,
      disabled: !serviceSelected?.sendReceiveMms,
    },
    {
      label: <span>{t("inbox.chatMessage.chatMessageFooter.camera")}</span>,
      className: "camera",
      key: "camera",
      icon: (
        <CameraOutlined
          style={{ fontSize: 18, color: "#626576", marginRight: 4 }}
        />
      ),
      onClick: () => {
        setIsOpenCamera(true);
        setOpenMessageTemplate(false);
      },
      disabled: !serviceSelected?.sendReceiveMms,
    },
    {
      label: (
        <span>{t("inbox.chatMessage.chatMessageFooter.photoOrVideo")}</span>
      ),
      key: "image",
      icon: <ImageIcon />,
      onClick: () => {
        inputUploadImgRef.current.value = [];
        inputUploadImgRef.current.click();
        setOpenMessageTemplate(false);
      },
      disabled: !serviceSelected?.sendReceiveMms,
    },
    {
      label: (
        <span>{t("inbox.chatMessage.chatMessageFooter.pdfDocument")}</span>
      ),
      key: "file",
      icon: <DocumentIcon />,
      onClick: () => {
        inputUploadImgRef.current.value = [];
        inputUploadFileRef.current.click();
        setOpenMessageTemplate(false);
      },
      disabled: !serviceSelected?.sendReceiveMms,
    },
  ];

  useEffect(() => {
    if (isUpdateLock) {
      handleLockConversation(conversationSelected, true);
    }
  }, [isUpdateLock]);

  useEffect(() => {
    // Handle unlock conversation when conversation is locked and idle
    if (
      newConversation &&
      newConversation.id === id &&
      !newConversation.lock &&
      newConversation.unlockIdle
    ) {
      setMessage("");
      setIsShowSendMessage(false);
      setIsOpenCamera(false);

      if (fileUploadImgList && fileUploadImgList.length > 0) {
        setFileUploadImgList([]);
        inputUploadImgRef.current.value = [];
      }
      if (fileUploadFileList && fileUploadFileList.length > 0) {
        setFileUploadFileList([]);
        inputUploadFileRef.current.value = [];
      }
    }
    // Handle clear message template in conversation when message template to sent
    if (
      newConversation &&
      newConversation.id === id &&
      message === newConversation?.lastMessage
    ) {
      setMessage("");
    }
  }, [newConversation?.lock, newConversation?.lastMessage]);

  useEffect(() => {
    if (
      isCurrentLockConversation &&
      conversationSelected &&
      conversationSelected.id &&
      !conversationSelected.lock
    ) {
      handleLockConversation(conversationSelected, true);
      if (conversationSelected.totalUnread > 0) {
        handleReadMessage();
      }
    }
  }, [isCurrentLockConversation]);

  useEffect(() => {
    loadDataMessageTemplate();
  }, [isGetMessTemplatePage]);

  useEffect(() => {
    loadDataMessageTemplate();
    handleGetCategory();
  }, []);

  useEffect(() => {
    // Handle check data when lock or unlock conversation
    if (
      fileUploadImgList?.length > 0 ||
      fileUploadFileList?.length > 0 ||
      message?.trim()?.length > 0
    ) {
      dispatch(setCurrentLockConversation(true));
      setIsShowSendMessage(true);
    }
    if (
      fileUploadImgList?.length === 0 &&
      fileUploadFileList?.length === 0 &&
      message?.trim()?.length === 0
    ) {
      handleLockConversation(conversationSelected, false);
      dispatch(setCurrentLockConversation(false));
      setIsShowSendMessage(false);
    }
  }, [message, fileUploadImgList.length, fileUploadFileList.length]);

  useEffect(() => {
    if (
      messageNotification &&
      messageNotification.conversationId === id &&
      messageNotification.body !== "" &&
      messageNotification.body !== undefined &&
      tags.length > 0
    ) {
      handleInputMessageByTag(messageNotification.body, tags);
    }
  }, [messageNotification.id]);

  useEffect(() => {
    const messageDraft = StorageHelper.getLocalItem(conversationSelected.id);
    if (messageDraft !== null) {
      if (conversationSelected && conversationSelected.id === id) {
        setMessage(messageDraft);
        dispatch(setCurrentLockConversation(true));
        setIsShowSendMessage(true);
        if (btnRef.current) {
          btnRef.current.click();
        }
        handleLockConversation(conversationSelected, true);
      }
    }
    if (
      messageDraft === null &&
      conversationSelected &&
      conversationSelected.id === id &&
      (fileUploadImgList?.length > 0 ||
        fileUploadFileList?.length > 0 ||
        message?.trim()?.length > 0)
    ) {
      setMessage("");
      setFileUploadImgList([]);
      setFileUploadFileList([]);
      setIsShowSendMessage(false);
      dispatch(setCurrentLockConversation(false));
    }
  }, [conversationSelected?.id]);

  const templateMessages = () => {
    return (
      <>
        {!isShowCategory && !isShowTemplate && (
          <>
            <Menu
              mode="vertical"
              // items={
              //   workspaceSetting?.sendReceiveMms ? items : items.slice(0, 1)
              // }
              items={items}
              className="more-actions-menu"
            />
          </>
        )}
        {isShowCategory && (
          <>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
            >
              <Button
                type="text"
                icon={<LeftOutlined />}
                onClick={() => {
                  setIsShowCategory(false);
                  setIsShowTemplate(false);
                }}
              />
              <Typography.Title level={5} style={{ margin: 0 }}>
                {t("inbox.chatMessage.chatMessageFooter.category")}
              </Typography.Title>
            </div>
            <div style={{ width: "500px" }}>
              {categoryList?.length === 0 ? (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              ) : (
                <div
                  id="scrollCategory"
                  style={{
                    marginTop: 16,
                    height: "150px",
                    overflow: "auto",
                  }}
                >
                  <InfiniteScroll
                    dataLength={categoryList?.length}
                    scrollableTarget="scrollCategory"
                  >
                    {categoryList?.map((categoryItem, index) => (
                      <div key={index}>
                        <Tag
                          onClick={() => {
                            setOpenMessageTemplate(true);
                            setIsShowTemplate(true);
                            setIsShowCategory(false);
                            setCategory(categoryItem);
                            handleGetPageMessageTemplate(categoryItem);
                          }}
                          color="#ECEEFD"
                          style={{
                            fontSize: 14,
                            padding: "8px 16px",
                            color: "#1F2EB4",
                            borderRadius: 8,
                            border: "1px solid #B6BFFF",
                            marginBottom: 8,
                            whiteSpace: "break-spaces",
                            cursor: "pointer",
                          }}
                        >
                          {categoryItem?.category}
                        </Tag>
                      </div>
                    ))}
                  </InfiniteScroll>
                </div>
              )}
            </div>
          </>
        )}
        {isShowTemplate && !isShowCategory && (
          <>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
            >
              <Button
                type="text"
                icon={<LeftOutlined />}
                onClick={() => {
                  setIsShowCategory(true);
                  setIsShowTemplate(false);
                }}
              />
              <Typography.Title level={5} style={{ margin: 0 }}>
                {t("inbox.chatMessage.chatMessageFooter.templates")}
              </Typography.Title>
            </div>
            <div style={{ width: "500px" }}>
              <Input
                size="large"
                placeholder="Search"
                prefix={<SearchOutlined />}
                onChange={handleSearchMessTemplate}
              />
              {messageTemplateList?.length === 0 &&
              !isLoadingMessageTemplate ? (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              ) : (
                <div
                  id="scrollTemplateMessage"
                  style={{
                    marginTop: 16,
                    height: "150px",
                    overflow: "auto",
                  }}
                >
                  <InfiniteScroll
                    dataLength={messageTemplateList?.length}
                    scrollableTarget="scrollTemplateMessage"
                    hasMore={hasMore}
                    next={hasMore && loadMoreMessageTemplate}
                    onScroll={handleScroll}
                  >
                    <List
                      className="demo-loadmore-list"
                      loading={isLoadingMessageTemplate}
                      itemLayout="horizontal"
                      dataSource={messageTemplateList}
                      renderItem={(messageTemplate, index) => (
                        <div key={index}>
                          <Tag
                            onClick={() => {
                              setMessage(
                                message + " " + messageTemplate?.message
                              );
                              inputSendMessageRef.current.focus({
                                cursor: "end",
                              });
                              setOpenMessageTemplate(false);
                              setIsShowSendMessage(true);
                            }}
                            color="#ECEEFD"
                            style={{
                              fontSize: 14,
                              padding: "8px 16px",
                              color: "#1F2EB4",
                              borderRadius: 8,
                              border: "1px solid #B6BFFF",
                              marginBottom: 8,
                              whiteSpace: "break-spaces",
                              cursor: "pointer",
                            }}
                          >
                            {messageTemplate?.title}
                          </Tag>
                        </div>
                      )}
                    />
                  </InfiniteScroll>
                </div>
              )}
            </div>
          </>
        )}
      </>
    );
  };

  return (
    <div className="chatMessageFooter">
      <button
        hidden
        ref={btnRef}
        onClick={() => {
          if (inputSendMessageRef.current) {
            inputSendMessageRef.current.focus();
          }
        }}
      />
      <div className="chatMessageFooterContent">
        <Popover
          overlayClassName="chatMessageTemplate"
          content={templateMessages}
          open={openMessageTemplate}
          placement="topLeft"
          trigger="click"
          destroyTooltipOnHide={true}
          onOpenChange={() => {
            setOpenMessageTemplate(!openMessageTemplate);
          }}
        />
        <Tooltip
          title={t("inbox.chatMessage.chatMessageFooter.openMoreActions")}
        >
          <Button
            type="primary"
            shape="circle"
            icon={<PlusOutlined />}
            onClick={() => {
              setOpenMessageTemplate(true);
              setIsShowTemplate(false);
              setIsGetMessTemplatePage(!isGetMessTemplatePage);
            }}
            disabled={
              isLockNotCurrentSessionConversation ||
              conversationSelected?.blockUser ||
              conversationSelected?.status === "DELETE"
            }
            style={{
              marginRight: 10,
            }}
          />
        </Tooltip>
        <div className="chatMessageFooterAction">
          <input
            type="file"
            ref={inputUploadFileRef}
            id="uploadFile"
            multiple
            accept=".pdf"
            onChange={handleBeforeUploadFile}
            style={{ display: "none" }}
          />
          <input
            type="file"
            ref={inputUploadImgRef}
            id="uploadImage"
            multiple
            accept="image/*,video/*"
            onChange={handleBeforeUploadImage}
            style={{ display: "none" }}
          />
        </div>
        <div style={{ width: "100%" }}>
          {/* Display file before upload */}
          {fileUploadImgList && fileUploadImgList.length > 0 && (
            <>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Typography.Title
                  level={5}
                  style={{ marginRight: "16px" }}
                >{`Total images or videos: ${fileUploadImgList.length}`}</Typography.Title>
                <div>
                  <Button
                    size="middle"
                    onClick={() => {
                      setFileUploadImgList([]);
                      inputUploadImgRef.current.value = [];
                    }}
                  >
                    {t(
                      "inbox.chatMessage.chatMessageFooter.removeAllImgOrVideo"
                    )}
                  </Button>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  maxWidth: 700,
                  overflow: "hidden",
                  overflowX: "auto",
                  marginTop: "8px",
                  paddingTop: "8px",
                }}
              >
                {fileUploadImgList.map((fileReview, index) => {
                  return (
                    <div key={index}>
                      {fileReview?.type === "image" && (
                        <>
                          <div
                            style={{
                              marginBottom: "12px",
                              marginRight: "12px",
                            }}
                          >
                            <div
                              style={{
                                position: "relative",
                                width: "50px",
                                height: "50px",
                              }}
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  left: 38,
                                  bottom: 32,
                                  zIndex: 1,
                                }}
                              >
                                <Button
                                  shape="circle"
                                  size="small"
                                  onClick={() => handleRemoveImage(fileReview)}
                                >
                                  <CloseOutlined />
                                </Button>
                              </div>
                              <img
                                src={fileReview.url}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  position: "absolute",
                                  objectFit: "cover",
                                  borderRadius: "10px",
                                }}
                              />
                            </div>
                          </div>
                        </>
                      )}
                      {fileReview?.type === "video" && (
                        <>
                          <div
                            style={{
                              marginBottom: "12px",
                              marginRight: "12px",
                            }}
                          >
                            <div
                              style={{
                                position: "relative",
                                width: "50px",
                                height: "50px",
                              }}
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  left: 38,
                                  bottom: 32,
                                  zIndex: 1,
                                }}
                              >
                                <Button
                                  shape="circle"
                                  size="small"
                                  onClick={() => handleRemoveImage(fileReview)}
                                >
                                  <CloseOutlined />
                                </Button>
                              </div>
                              <video
                                src={fileReview.url}
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  position: "absolute",
                                  objectFit: "cover",
                                  borderRadius: "10px",
                                  pointerEvents: "none",
                                }}
                              />
                              <div
                                style={{
                                  position: "absolute",
                                  left: 14,
                                  bottom: 12,
                                  zIndex: 1,
                                }}
                              >
                                <PlayCircleFilled
                                  style={{ color: "#fff", fontSize: 24 }}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  );
                })}
              </div>
            </>
          )}

          {fileUploadFileList && fileUploadFileList.length > 0 && (
            <>
              <div style={{ display: "flex", alignItems: "center" }}>
                <Typography.Title
                  level={5}
                  style={{ marginRight: "16px" }}
                >{`Total files: ${fileUploadFileList.length}`}</Typography.Title>
                <div>
                  <Button
                    size="middle"
                    onClick={() => {
                      setFileUploadFileList([]);
                      inputUploadFileRef.current.value = [];
                    }}
                  >
                    {t("inbox.chatMessage.chatMessageFooter.removeAllFile")}
                  </Button>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  maxWidth: 700,
                  overflow: "hidden",
                  overflowX: "auto",
                  marginTop: "8px",
                  paddingTop: "8px",
                }}
              >
                {fileUploadFileList.map((fileReview, index) => {
                  return (
                    <div key={index}>
                      {fileReview?.type === "file" && (
                        <>
                          <div
                            style={{
                              marginBottom: "12px",
                              marginRight: "12px",
                            }}
                          >
                            <div
                              style={{
                                width: "150px",
                                padding: "8px",
                                backgroundColor: "#DEE1E5",
                                borderRadius: "10px",
                                position: "relative",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <Avatar
                                  icon={<FileTextOutlined />}
                                  style={{
                                    backgroundColor: "#fff",
                                    color: "#000",
                                  }}
                                />
                                <Typography.Text
                                  style={{
                                    marginLeft: 8,
                                    width: "100px",
                                    whiteSpace: "nowrap",
                                    textOverflow: "ellipsis",
                                    overflow: "hidden",
                                    fontWeight: "500",
                                  }}
                                >
                                  {fileReview.file?.name}
                                </Typography.Text>
                              </div>
                              <div
                                style={{
                                  position: "absolute",
                                  left: 134,
                                  bottom: 32,
                                  zIndex: 1,
                                }}
                              >
                                <Button
                                  shape="circle"
                                  size="small"
                                  onClick={() => handleRemoveFile(fileReview)}
                                >
                                  <CloseOutlined />
                                </Button>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  );
                })}
              </div>
            </>
          )}
          {!isStartAudioRecording && (
            <>
              <TextArea
                id="inputSendMessage"
                ref={inputSendMessageRef}
                value={message}
                autoFocus
                onChange={handleInputMessage}
                disabled={
                  isLockNotCurrentSessionConversation ||
                  conversationSelected?.blockUser ||
                  conversationSelected?.status === "DELETE"
                }
                style={{
                  width: "100%",
                  overflowY: "auto",
                  padding: 10,
                }}
                placeholder={t(
                  "inbox.chatMessage.chatMessageFooter.typeMessage"
                )}
                autoSize={{
                  maxRows: 5,
                }}
                onKeyDown={e => {
                  handleKeyPress(e);
                }}
                onKeyUp={async e => {
                  await handleKeyUp(e);
                }}
              />
            </>
          )}
          {isStartAudioRecording && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <Tooltip title="Discard voice message">
                <Button
                  type="text"
                  shape="circle"
                  onClick={() => {
                    audioRecordRef?.current?.handleDiscardRecord();
                    dispatch(setCurrentLockConversation(false));
                    handleLockConversation(conversationSelected, false);
                    setIsStartAudioRecording(false);
                  }}
                  icon={<DeleteOutlined />}
                  style={{ marginRight: 8 }}
                />
              </Tooltip>
              <AudioRecord
                ref={audioRecordRef}
                isStartAudioRecording={isStartAudioRecording}
                setIsStartAudioRecording={setIsStartAudioRecording}
                setAudioFile={setFileAudioUpload}
              />
              <Tooltip title="Send audio message">
                <Button
                  type="text"
                  shape="circle"
                  onClick={() => {
                    audioRecordRef?.current?.handleRecordingComplete();
                  }}
                  icon={<SendMessHorizontalBlueIcon />}
                  style={{ marginLeft: 8 }}
                />
              </Tooltip>
            </div>
          )}
        </div>
        {isShowSendMessage &&
          isCurrentLockConversation &&
          !isLockNotCurrentSessionConversation &&
          !isStartAudioRecording && (
            <Tooltip
              title={t("inbox.chatMessage.chatMessageFooter.sendMessage")}
            >
              <Button
                type="link"
                style={{ padding: 4 }}
                onClick={() => {
                  if (
                    message?.trim() !== "" ||
                    (fileUploadImgList && fileUploadImgList.length > 0) ||
                    (fileUploadFileList && fileUploadFileList.length > 0)
                  ) {
                    handleSendMessage([
                      ...fileUploadImgList,
                      ...fileUploadFileList,
                    ]);
                  }
                }}
                disabled={loading || isLockNotCurrentSessionConversation}
              >
                <SendMessHorizontalBlueIcon />
              </Button>
            </Tooltip>
          )}
      </div>
      <ModalForm
        title={
          isShowVideo
            ? t("inbox.chatMessage.chatMessageFooter.takeAVideo")
            : t("inbox.chatMessage.chatMessageFooter.takeAPhoto")
        }
        onCancel={() => {
          handleLockConversation(conversationSelected, false);
          setIsOpenCamera(false);
          setIsShowVideo(false);
          setIsCaptureSuccess(false);
        }}
        isOpen={isOpenCamera}
        customWidth={450}
        footer={false}
        destroyOnClose={true}
      >
        <Camera
          setIsCaptureSuccess={setIsCaptureSuccess}
          isCaptureSuccess={isCaptureSuccess}
          isShowVideo={isShowVideo}
          setIsShowVideo={setIsShowVideo}
          conversationSelected={conversationSelected}
          setIsShowSendMessage={setIsShowSendMessage}
          setIsOpenCamera={setIsOpenCamera}
          handleLockConversation={handleLockConversation}
          setFileUploadImgList={setFileUploadImgList}
        />
      </ModalForm>
    </div>
  );
};

export default ChatMessageFooter;
